/**
 *
 * withEditClubs
 * HOC to add editing route and action
 *
 */

// import React from 'react';
// import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { makeSelectTravelMode } from 'containers/MapPage/selectors';
import makeSelectEditService from './selectors';
import {
  editAdd,
  editClear,
  editCreate,
  editDelete,
  editEdit,
  editMove,
  editReplace,
  editInsert,
  editSave,
  editUndo,
} from './actions';

const mapStateToProps = createStructuredSelector({
  workingRoute: makeSelectEditService(),
  travelMode: makeSelectTravelMode(),
});

function mapDispatchToProps(dispatch) {
  return {
    addPoint: (point, travelMode) => dispatch(editAdd(point, travelMode)),
    deletePoint: (id, travelMode) => dispatch(editDelete(id, travelMode)),
    insertPoint: (id, point, travelMode) =>
      dispatch(editInsert(id, point, travelMode)),
    movePoint: (id, point, travelMode) =>
      dispatch(editMove(id, point, travelMode)),
    replacePath: (id, travelMode) => dispatch(editReplace(id, travelMode)),
    clearRoute: forceEmpty => dispatch(editClear(forceEmpty)),
    createRoute: () => dispatch(editCreate()),
    editRoute: id => dispatch(editEdit(id)),
    saveRoute: () => dispatch(editSave()),
    undo: () => dispatch(editUndo()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default withConnect;
